<template>
  <div class="animated fadeIn">
    <user-form v-bind:user="this.user" :roles="this.roles" :teams="this.teams" :accounts="this.accounts" :isSuperAdmin="this.isSuperAdmin" :isAdmin="this.isAdmin" :editUser="false" @formSubmit="createUser" @formReset="resetForm"></user-form>
  </div>
</template>

<script>
import Vue from 'vue'
import router from '../../router'
import { mapGetters } from 'vuex'
import userForm from '@/components/admin/userForm'

export default {
  components: {
    'user-form': userForm
  },
  data () {
    return {
      user: {
        username: '',
        email: '',
        password: null,
        repeat_password: null,
        role_id: '',
        account_id: '',
        notify: false,
        team_id: ''
      },
      roles: [],
      accounts: [],
      teams: []
    }
  },
  computed: {
    ...mapGetters(['idToken', 'isSuperAdmin', 'isAdminRole', 'isAdmin'])
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      if (vm.isAdminRole) {
        Vue.axios.get('/admin/users/accounts_and_roles', { headers: { Authorization: `Bearer ${vm.idToken}` } })
          .then(res => {
            vm.roles = res.data.roles
            vm.accounts = res.data.accounts
            vm.teams = res.data.teams
            next()
          })
          .catch(error => {
            if (error.status === 401) {
              Vue.toasted.show(vm.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
              console.log(this.$t('COMMON.MSG_EXPIRED'))
            } else {
              Vue.toasted.show(vm.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
              next(false)
            }
          })
      } else {
        router.replace('/Not-Found-404')
      }
    })
  },
  methods: {
    createUser () {
      let data = new window.FormData()
      var domain = window.location.origin
      data.append('username', this.user.username)
      data.append('email', this.user.email)
      data.append('password', this.user.password)
      data.append('role_id', this.user.role_id)
      data.append('account_id', this.user.account_id)
      data.append('notify', this.user.notify)
      data.append('domain', domain)
      data.append('team_id', this.user.team_id)
      Vue.axios.post('/admin/users', data, { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(res => {
          if (res.data.error) {
            Vue.toasted.show(res.data.error, { icon: 'chain-broken', type: 'error' })
          } else {
            Vue.toasted.show(this.$t('COMMON.MSG_USER_CREATE'))
            router.push('/admin/users')
          }
        })
        .catch(error => {
          Vue.toasted.show(this.$t('COMMON.MSG_SIGNUP_FAIL'),
            { icon: 'chain-broken', type: 'error' })
          console.log(error)
        })
    },
    resetForm () {
      this.user.username = ''
      this.user.email = ''
      this.user.password = null
      this.user.repeat_password = null
      this.user.role_id = ''
      this.user.notify = false
      this.user.account_id = ''
      this.user.team_id = ''
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/admin/newUser.vue